import { render, staticRenderFns } from "./7.vue?vue&type=template&id=741cc82a&scoped=true&"
import script from "./7.vue?vue&type=script&lang=js&"
export * from "./7.vue?vue&type=script&lang=js&"
import style0 from "./7.vue?vue&type=style&index=0&id=741cc82a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741cc82a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('741cc82a')) {
      api.createRecord('741cc82a', component.options)
    } else {
      api.reload('741cc82a', component.options)
    }
    module.hot.accept("./7.vue?vue&type=template&id=741cc82a&scoped=true&", function () {
      api.rerender('741cc82a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/7.vue"
export default component.exports